// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import thumbsUpIcon from "@/assets/icons/thumbs-up.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ThumbsUpIconProps = Omit<IconProps, "name">;

export function ThumbsUpIcon(props: ThumbsUpIconProps): React.ReactNode {
  return <Icon name={thumbsUpIcon} {...props} />;
}
